import React from 'react';
import colors from 'src/style/colors';
import { Paragraph } from '../Typography';

import Star from '../Icons/Star';
import { Avatar } from '../../components/Avatars';
import { mediaQueries } from 'src/style/breakpoints';

import logoGoogle from '../../data/images/googleLogo2.png';

const ReviewCard = ({
  text,
  author,
  avatar,
  withoutAvatar,
  reviewLink,
  className,
  course,
  title,
}) => {
  return (
    <div
      className={className}
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: 743,
        marginTop: 70,
        marginBottom: 0,
        transition: 'transform 300ms ease-out',
        [mediaQueries.phoneOnly]: {
          marginRight: 5,
          marginLeft: 5,
          width: '80vw',
        },
        [mediaQueries.tabletPortraitUp]: {
          marginRight: 10,
          marginLeft: 10,
          width: '80vw',
        },
        [mediaQueries.desktopUp]: {
          width: '100vw',
        },
      }}
    >
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          position: 'relative',
          backgroundColor: colors.lightGrey,
          borderRadius: 5,
          width: '100%',
          boxShadow: 'rgba(0, 0, 0, 0.08) 0px 3px 10px',
          marginBottom: '10px',
          [mediaQueries.phoneOnly]: {
            minWidth: 250,
          },
          [mediaQueries.tabletPortraitUp]: {
            /*      width: 550, */
          },
          [mediaQueries.tabletLandscapeUp]: {
            minWidth: 745,
          },
        }}
      >
        {withoutAvatar || avatar === false ? null : (
          <div
            css={{
              position: 'absolute',
              top: '-55px',
              zIndex: 1,
              [mediaQueries.tabletPortraitUp]: {
                // left: 55,
                top: '-65px',
              },
            }}
          >
            <Avatar name={avatar} big={true} alt={`photographie de ${author}`} />
          </div>
        )}
        <Paragraph
          css={{
            color: colors.purpleDark,
            alignSelf: 'center',
            padding: '0 0 10px 0',
            fontWeight: 'bold',
            paddingTop: withoutAvatar || avatar === false ? 30 : 75,
            [mediaQueries.tabletPortraitUp]: {
              paddingTop: 50,
            },
          }}
        >
          {author}
        </Paragraph>
        {course === 'landingPage' ? (
          <Paragraph
            css={{
              color: colors.purple,
              fontWeight: 'bold',
              padding: '5px 20px 5px 20px',
              textAlign: 'center',
              [mediaQueries.tabletPortraitUp]: {
                padding: '10px 50px 0px 50px',
              },
            }}
          >
            {title}
          </Paragraph>
        ) : (
          <div
            css={{
              display: 'flex',
              flexDirection: 'row',
              '&>svg': {
                marginLeft: 5,
              },
            }}
          >
            <Star />
            <Star />
            <Star />
            <Star />
            <Star />
          </div>
        )}

        <Paragraph
          css={{
            color: colors.purpleDark,
            fontStyle: course === 'landingPage' ? 'italic' : 'normal',
            padding: course === 'landingPage' ? '10px 20px 20px 20px' : '20px 20px 20px 20px',
            textAlign: 'center',
            [mediaQueries.phoneOnly]: {
              fontSize: 16,
              lineHeight: '22px',
            },
            [mediaQueries.tabletPortraitUp]: {
              fontSize: 18,
              lineHeight: '27px',
              padding: course === 'landingPage' ? null : '30px 50px 20px 50px',
            },
          }}
        >
          {text}
        </Paragraph>

        {course === 'landingPage' ? null : (
          <Paragraph
            css={{
              fontSize: 13,
              [mediaQueries.phoneOnly]: {
                fontSize: 13,
              },
              color: colors.purpleDark,
              alignSelf: 'center',
              padding: '0px 0px 30px 0px',
            }}
          >
            {reviewLink ? (
              <a
                href={reviewLink}
                rel="noopener noreferrer"
                target="_blank"
                style={{
                  color: colors.purpleDark,
                  textDecoration: 'none',
                }}
              >
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  Avis
                  <img src={logoGoogle} alt="logo Google" css={{ width: '50px', height: '100%' }} />
                </span>
              </a>
            ) : (
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                Avis
                <img src={logoGoogle} alt="logo Google" css={{ width: '50px', height: '100%' }} />
              </span>
            )}
          </Paragraph>
        )}
      </div>
    </div>
  );
};

export default ReviewCard;

// const linkStyle = {
//   fontSize: 16,
//   lineHeight: '28px',
//   padding: 0,
//   // color: colors.white,
//   transitionDuration: '0.3s',
//   transitionTimingFunction: 'ease-in-out',
//   transitionDelay: '0s',
//   textDecoration: 'none',
//   letterSpacing: 0.4,
//   [mediaQueries.phoneOnly]: {
//     lineHeight: '24px',
//     paddingBottom: 8,
//   },
//   [mediaQueries.tabletPortraitUp]: {
//     lineHeight: '24px',
//     paddingBottom: 8,
//   },
//   '&:hover': {
//     color: colors.yellow,
//   },
// };
